:host,
:host *,
:host *::before,
:host *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:host {
  flex: 1;
  width: 100%;
}

#slider-container {
  display: flex;
  width: 100%;
  height: 100%;
  gap: 64px;
  align-items: center;
  user-select: none;
}

#slider-content {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 64px;
  overflow: hidden;
}

.icon-button {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--grid-border-action-primary-ghost);
  border-radius: 100%;
  background: none;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: pointer;
}

.icon-button:hover {
  border-color: var(--grid-border-action-primary-ghost-hover);
}

.icon-button:hover svg * {
  fill: var(--grid-content-on-action-primary-ghost-hover);
}

.icon-button:disabled {
  border-color: var(--grid-border-action-primary-ghost-disabled);
  cursor: default;
}

.icon-button:disabled svg * {
  fill: var(--grid-content-on-action-primary-ghost-disabled);
}

#slider-container.animated .icon-button.next,
#slider-container.animated #pagination {
  animation: fadeIn var(--duration-xslow) var(--curve-expressive-ease-out) 1.75s forwards;
}

#slider-container.animated.refreshed .icon-button.next,
#slider-container.animated #pagination {
  animation: fadeIn var(--duration-xslow) var(--curve-expressive-ease-out) 0.85s forwards;
}

#slider-container.animated .icon-button.previous {
  animation: slideInFromLeft var(--duration-xslow) var(--curve-expressive-ease-out) 1.75s forwards;
}

#slider-container.animated.refreshed .icon-button.previous {
  animation: slideInFromLeft var(--duration-xslow) var(--curve-expressive-ease-out) 0.85s forwards;
}

.icon {
  display: block;
  width: 24px;
  height: 24px;
}

.icon-button.next .icon {
  transform: translateX(1px);
}

.icon-button.previous .icon {
  transform: rotate(180deg) translateX(1px);
}

#slider-texts,
#slider-images {
  flex: 1;
  height: 100%;
  display: flex;
  position: relative;
}

#slider-images {
  justify-content: center;
  align-items: center;
  min-height: 440px;
}

#slider-container.animated.ended #slider-images {
  min-height: 352px;
}

#slider-images-background {
  position: absolute;
  width: 100%;
  max-height: 100%;
  aspect-ratio: 0.75;
  opacity: 0;
}

#slider-texts {
  flex-direction: column;
  gap: 32px;
  overflow-x: hidden;
  overflow-y: hidden;
  user-select: text;
}

#buttons-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fill-container {
  flex: 1;
  width: 100%;
}

.fill-container:not(#cta-appuntamento-container) {
  max-height: 48px;
}

#cta-appuntamento-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  font: var(--headline-5);
  color: var(--grid-content-primary);
  opacity: 0;
  margin-top: 32px;
}

#last-slide-container #cta-appuntamento-container {
  margin-top: 44px;
}

#slider-container.animated #cta-appuntamento-container {
  animation: slideInFromBottom var(--duration-xslow) var(--curve-expressive-ease-out) 1.45s forwards;
}

#slider-container.animated.refreshed #cta-appuntamento-container {
  animation: slideInFromBottom var(--duration-xslow) var(--curve-expressive-ease-out) 0.55s forwards;
}

#slider-container #last-slide-container #cta-appuntamento-container {
  animation-delay: 0.25s;
}

#button-primary,
#button-secondary {
  opacity: 0;
}

#slider-container.animated #button-primary {
  animation: slideInFromBottom var(--duration-xslow) var(--curve-expressive-ease-out) 1.25s forwards;
}

#slider-container.animated.refreshed #button-primary {
  animation: slideInFromBottom var(--duration-xslow) var(--curve-expressive-ease-out) 0.35s forwards;
}

#slider-container.animated.ended #button-primary,
#slider-container.animated.ended #button-secondary,
#slider-container.animated.ended #cta-appuntamento-container {
  opacity: 1;
  animation: none;
}

#slider-container.animated #button-secondary {
  animation: slideInFromBottom var(--duration-xslow) var(--curve-expressive-ease-out) 1.35s forwards;
}

#slider-container.animated.refreshed #button-secondary {
  animation: slideInFromBottom var(--duration-xslow) var(--curve-expressive-ease-out) 0.45s forwards;
}

#slider-container.animated #slides-content-container {
  animation: slideInFromBottom var(--duration-xslow) var(--curve-expressive-ease-out) 1.1s forwards;
}

#slider-container.animated.refreshed #slides-content-container {
  animation: slideInFromBottom var(--duration-xslow) var(--curve-expressive-ease-out) 0.2s forwards;
}

#slider-container.animated #slider-images-background {
  animation: spinIn var(--duration-extended-1) var(--curve-cinematic-ease-out) 1.55s forwards;
}

#slider-container.animated.refreshed #slider-images-background {
  animation: spinIn var(--duration-extended-1) var(--curve-cinematic-ease-out) 0.55s forwards;
}

#background-bubble-1,
#background-bubble-2,
#background-bubble-3 {
  position: absolute;
  border-radius: 100%;
  aspect-ratio: 1;
  transition: all var(--duration-xslow) var(--curve-expressive-ease-in-out);
}

#slider-container.animated.ended #background-bubble-1,
#slider-container.animated.ended #background-bubble-2,
#slider-container.animated.ended #background-bubble-3 {
  transition-delay: 0.3s;
}

#background-bubble-1 {
  width: 20%;
  top: 15%;
  left: 3%;
  background: var(--grid-background-product-02);
}

#slider-container.animated.ended #background-bubble-1 {
  width: 90%;
  top: 0%;
  left: -10%;
  background: var(--grid-background-product-02);
}

#background-bubble-2 {
  width: 50%;
  right: 0;
  top: 30%;
  background: var(--grid-background-product-04);
}

#slider-container.animated.ended #background-bubble-2 {
  width: 35%;
  top: 60%;
}

#background-bubble-3 {
  width: 80%;
  left: 0;
  bottom: 16px;
  background: var(--grid-background-product-03);
}

#slider-container.animated.ended #background-bubble-3 {
  width: 10%;
  left: 45%;
  bottom: 0;
}

#slider-image-items-container {
  flex: 1;
  height: 100%;
  transform: scale(0);
  display: flex;
  justify-content: center;
}

#slider-container.animated #slider-image-items-container {
  animation: popIn var(--duration-xslow) var(--curve-expressive-ease-out) 1.75s forwards;
}

#slider-container.animated.refreshed #slider-image-items-container {
  animation: popIn var(--duration-xslow) var(--curve-expressive-ease-out) 0.4s forwards;
}

.slider-image-item {
  position: absolute;
  top: 0;
  bottom: 0;
  aspect-ratio: 0.52;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: none;
}

.slider-image-item.loop {
  display: none;
}

.slider-image-item.current {
  z-index: 1;
  opacity: 1;
  transform: translateX(0) scale(1);
  transition: opacity var(--duration-medium-2) var(--curve-expressive-ease-out) 0.1s, transform var(--duration-medium-3) var(--curve-expressive-ease-out) 0.1s;
}

.slider-image-item.previous,
.slider-image-item.next {
  transition: opacity var(--duration-fast) var(--curve-expressive-ease-in), transform var(--duration-medium-1) var(--curve-expressive-ease-in);
}

.slider-image-item.previous {
  transform: translateX(-60%) scale(0.5);
}

.slider-image-item.next {
  transform: translateX(60%) scale(0.5);
}

.slider-image-item.previous-previous {
  transform: translateX(-100%) scale(0.25);
}
.slider-image-item.next-next {
  transform: translateX(100%) scale(0.25);
}

.slider-image-item.hidden {
  opacity: 0;
  visibility: hidden;
  transition: none;
}

.slider-image {
  height: 100%;
  max-height: 100%;
  max-width: 95%;
  object-fit: contain;
  /* border: 4px solid #d0e2ff; */
  /* border-radius: 16px; */
  /* border-bottom-width: 10px;
  border-top-width: 10px; */
  /* background: #d0e2ff; */
}

#slides-content-container {
  display: flex;
  flex-direction: column;
  opacity: 0;
  gap: 32px;
}

.slider-text-items-container {
  display: inline-flex;
  gap: 8px;
  transition: transform var(--duration-xslow) var(--curve-expressive-ease-out);
}

.slider-text-item {
  display: flex;
  width: 100%;
  flex-shrink: 0;
  flex-direction: column;
  gap: 8px;
  color: var(--grid-content-primary);
  opacity: 0;
  transition: opacity var(--duration-medium-2) var(--curve-expressive-ease-out);
}

.slider-text-item.current {
  opacity: 1;
  transition: opacity var(--duration-medium-2) var(--curve-expressive-ease-out);
}

.slide-title {
  font: var(--headline-5);
  margin: 0;
  padding: 0;
}

.slide-paragraph {
  font: var(--body-3);
  margin: 0;
  padding: 0;
}

#slider-container.animated.ended .icon-button,
#slider-container.animated.refreshed.ended .icon-button {
  pointer-events: none;
  animation: fadeOut var(--duration-fast) var(--curve-simple-ease-in) forwards;
}

#slider-container.animated.ended #slides-content-container,
#slider-container.animated.ended #slider-image-items-container {
  animation: slideOut var(--duration-medium-2) var(--curve-expressive-ease-in) forwards;
}

#last-slide-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  opacity: 0;
  animation: slideInFromBottom var(--duration-slow) var(--curve-expressive-ease-out) 0.4s forwards;
}

#last-slide-container.refreshing {
  opacity: 1;
  animation: slideOutToBottom var(--duration-medium-2) var(--curve-expressive-ease-in) forwards;
}

#app-links {
  display: flex;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 8px;
}

.last-slide-title {
  font: var(--title-5);
  color: var(--grid-content-primary);
  max-width: 20ch;
}

#qr-code-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  gap: 12px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

#qr-code-container {
  /* background: var(--grid-background-color-02); */
  /* border-radius: 16px; */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 280px;
  aspect-ratio: 1;
  /* padding: 80px; */
  position: relative;
  opacity: 0;
  animation: slideInFromBottom var(--duration-slow) var(--curve-expressive-ease-out) 0.4s forwards;
}

#qr-code-container.refreshing {
  opacity: 1;
  animation: slideOutToBottom var(--duration-medium-2) var(--curve-expressive-ease-in) forwards;
}

#qr-code-container img {
  width: 100%;
  height: 100%;
}

#pagination {
  display: flex;
  gap: 8px;
  justify-content: center;
  opacity: 0;
}

.pagination-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px solid var(--grid-action-accent);
}

.pagination-dot.active {
  background: var(--grid-action-accent);
}

@media screen and (max-width: 1200px) {
  #slider-container {
    gap: 48px;
  }

  .slider-image {
    max-width: 90%;
  }
}

@media screen and (max-width: 989px) {
  /* .icon-button {
    display: none;
  } */

  #slider-container {
    gap: 124px;
  }

  #slider-content {
    flex-direction: column;
    gap: 16px;
    overflow: visible;
    width: 0;
    justify-content: flex-start;
  }

  .fill-container {
    display: none;
    flex: unset;
    height: auto;
  }

  #slider-texts {
    flex: unset;
    height: auto;
    width: calc(100% + 152px);
    padding-bottom: 8px;
    /* visibility: hidden; */
  }

  /* .slider-text-items-container {
    display: none;
  } */

  #slider-images-background {
    width: calc(100% + 152px);
  }

  #slider-images {
    width: 100%;
    aspect-ratio: 0.52;
    height: unset;
    flex: unset;
    pointer-events: none;
  }

  #slider-image-items-container {
    width: 100%;
    height: 100%;
  }

  .slider-image {
    max-height: 100%;
    max-width: 100%;
  }

  #buttons-container {
    display: none;
  }

  /* .slider-image-item {
    opacity: 1;
  } */

  /* .slider-image-item.loop {
    display: flex;
  }

  .slider-image-item::after {
    content: '';
    display: block;
    position: absolute;
    background: black;
    height: 100%;
    aspect-ratio: 0.52;
    border-radius: 16px;
    opacity: 0;
    transition: opacity var(--duration-medium-3) var(--curve-expressive-ease-in-out);
  }

  .slider-image-item.previous::after,
  .slider-image-item.previous-previous::after,
  .slider-image-item.next::after,
  .slider-image-item.next-next::after {
    opacity: 0.1;
    transition: opacity var(--duration-medium-3) var(--curve-expressive-ease-in-out) 0.1s;
  }

  .slider-image-item.current {
    transition: transform var(--duration-extended-1) var(--curve-expressive-ease-in-out) 0.05s;
  }

  .slider-image-item.previous {
    transform: translateX(calc(-110%)) scale(0.75);
    transition: transform var(--duration-extended-1) var(--curve-expressive-ease-in-out) 0.025s;
  }

  .slider-image-item.previous-previous {
    transform: translateX(-220%) scale(0.5);
    transition: transform var(--duration-extended-1) var(--curve-expressive-ease-in-out);
  }

  .slider-image-item.next {
    transform: translateX(110%) scale(0.75);
    transition: transform var(--duration-extended-1) var(--curve-expressive-ease-in-out) 0.05s;
  }

  .slider-image-item.next-next {
    transform: translateX(220%) scale(0.5);
  }

  .slider-image-item.initial {
    transition: none;
  }
  .slider-image-item.initial::after {
    transition: none;
  } */

  #slides-content-container {
    gap: 24px;
  }

  #cta-appuntamento-container {
    margin-top: 0;
    font-weight: 400;
    padding-top: 8px;
    width: calc(100vw - 32px);
    text-align: center;
    display: inline-block;
  }

  #cta-appuntamento {
    display: inline;
  }

  #cta-appuntamento-container .link {
    color: var(--grid-content-primary);
    font-weight: 700;
  }

  #slider-container.animated #slider-images-background {
    animation-delay: 1.1s;
  }

  #slider-container.animated.refreshed #slider-images-background {
    animation-delay: 0.4s;
  }

  #slider-container.animated #slider-image-items-container {
    animation-delay: 1.3s;
  }

  #slider-container.animated.refreshed #slider-image-items-container {
    animation-delay: 0.6s;
  }
}

@media screen and (max-width: 767px) {
  .icon-button {
    width: 32px;
    height: 32px;
    background: var(--grid-action-secondary);
    position: relative;
  }

  .icon-button::before {
    position: absolute;
    content: '';
    display: block;
    top: -8px;
    bottom: -8px;
    left: -8px;
    right: -8px;
  }

  .icon-button:hover {
    background: var(--grid-action-secondary-hover);
  }

  .icon-button svg,
  .icon-button .icon {
    width: 16px;
    height: 16px;
  }

  .icon-button svg * {
    fill: var(--grid-content-on-action-secondary);
  }

  .icon-button:hover svg * {
    fill: var(--grid-content-on-action-secondary-hover);
  }

  .icon-button:disabled {
    border-color: var(--grid-border-action-disabled);
    background: var(--grid-action-disabled);
    cursor: default;
  }

  .icon-button:disabled svg * {
    fill: var(--grid-content-on-action-secondary-disabled);
  }

  #slider-container {
    gap: 24px;
  }

  #slider-images {
    min-height: 320px;
    pointer-events: none;
  }

  #slider-texts {
    gap: 16px;
    width: calc(100vw - 32px);
    padding-bottom: 8px;
    /* visibility: hidden; */
  }

  #slider-images-background {
    max-width: unset;
    width: 100vw;
    z-index: -1;
  }

  #slider-container.animated #slider-images-background {
    animation-name: spinInMobile;
  }

  #background-bubble-2 {
    top: 25%;
  }

  #background-bubble-3 {
    width: 65%;
    bottom: 0;
  }

  #slider-content {
    gap: 16px;
  }

  .slider-image-item.previous {
    transform: translateX(calc(-95%)) scale(0.75);
  }

  .slider-image-item.previous-previous {
    transform: translateX(-200%) scale(0.5);
  }

  .slider-image-item.next {
    transform: translateX(95%) scale(0.75);
  }

  .slider-image-item.next-next {
    transform: translateX(200%) scale(0.5);
  }

  #slides-content-container {
    gap: 16px;
  }

  #cta-appuntamento-container {
    font-size: 14px;
  }
}

@keyframes slideInFromBottom {
  0% {
    opacity: 0;
    transform: translateY(48px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromLeft {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes slideInFromRight {
  0% {
    transform: translateX(48px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes spinIn {
  0% {
    opacity: 0.2;
    transform: scale(0) rotate(200deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0);
  }
}

@keyframes spinInMobile {
  0% {
    opacity: 0;
    transform: scale(0) rotate(200deg);
  }
  100% {
    opacity: 0.3;
    transform: scale(1) rotate(0);
  }
}

@keyframes popIn {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes bubble1 {
  0% {
    transform: translate(100%, 80%);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes bubble2 {
  0% {
    transform: translate(-30%, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes bubble3 {
  0% {
    transform: translate(10%, -15%);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes slideOut {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-48px);
  }
}

@keyframes slideOutToBottom {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(48px);
  }
}

@keyframes slideOutToBottomL {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(88px);
  }
}
